export default {
  items: [
    {
      name: 'Menu Principal',
      icon: 'icon-speedometer',
      children: [
        // {
        //   name: 'Beneficiárias',
        //   url: '/beneficiarias',
        //   icon: 'fa fa-users'
        // },
        // {
        //   name: 'Disponibilidade',
        //   url: '/informar-disponibilidade',
        //   icon: 'fa fa-calendar'
        // },
        // {
        //   name: 'Minha Agenda',
        //   url: '/minha-agenda',
        //   icon: 'fa fa-calendar'
        // },
        {
          name: 'Relatórios de Encontros',
          url: '/relatorio-encontros',
          icon: 'fa fa-book'
        },
        {
          name: 'Realizar um Feedback',
          url: '/feedbacks/novo',
          icon: 'fa fa-comments-o'
        },
        {
          name: 'Depoimentos',
          url: '/depoimentos/list',
          icon: 'fa fa-commenting-o'
        },
        {
          name: 'Perguntas e Respostas',
          url: '/faqs/list',
          icon: 'fa fa-question-circle'
        },
        {
          name: 'Informações e Notícias',
          url: '/informacoes-noticias',
          icon: 'fa fa-info'
        },
        {
          name: 'Cursos',
          url: '/cursos-listar',
          icon: 'fa fa-youtube-play'
        },
        {
          name: 'Programas de Governo',
          url: '/programas-listar',
          icon: 'fa fa-tasks'
        },
        {
          name: 'Programas do Município',
          url: 'programas-municipios-listar',
          icon: 'fa fa-tasks'
        },
        {
          name: 'Regulamento do Projeto',
          url: '/arquivos-regulamento',
          icon: 'fa fa-files-o'
        },
        {
          name: 'Termo do Voluntariado',
          url: '/arquivos-termo',
          icon: 'fa fa-files-o'
        },
        {
          name: 'Guia do Encontro',
          url: '/arquivos-guia',
          icon: 'fa fa-files-o'
        },
        {
          name: 'Ebook Mães Unidas',
          url: '/arquivos-ebook',
          icon: 'fa fa-files-o'
        },
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_navVoluntario.js